import { json, status } from "../../fetchUtils";
import idempotence from "../../idempotence";
import nodeListToArray from "../../nodeListToArray";
import ready from "../../ready";

const postDropdownComponentLoader = {
  init() {
    nodeListToArray(
      document.querySelectorAll("[data-js-load-post-dropdown-component]")
    ).forEach((loader) => {
      if (!idempotence.guard(loader, "load-post-dropdown-component")) {
        const path = `/posts/${loader.dataset.jsLoadPostDropdownComponent}/load_dropdown_component`;
        const url = new URL(path, window.location.origin);
        fetch(url.toString(), { method: "GET" })
          .then(status)
          .then(json)
          .then((response) => {
            loader.innerHTML = response.component;
            FontAwesome.dom.i2svg(); // replace the icon tags with svgs
          });
      }
    });
  },
};

ready(() => {
  postDropdownComponentLoader.init();
});

export default postDropdownComponentLoader;
